module.exports = __webpack_public_path__ + "static/1.0_543x800_Mobile_Hero_2X-3027d24a4a59f4cfecb9981c61b4c284.png";